import styled from '@emotion/styled';

export const BoxLogo = styled.div`
  width: 260px;
  height: 80px;
  background: rgba(55, 71, 79, 1);
`;

export const BoxTitle = styled.div`
  width: 806px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(245, 247, 248, 0.6);
`;

export const HeaderBox = styled.div`
  max-width: 1366px;
  width: 1066px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
